module.exports = __webpack_public_path__ + "static/media/icon-speaker-white.0e422712.svg";